import { InjectionToken } from '@angular/core';

export const NEBULA_APP_CONFIG = new InjectionToken<any>('NEBULA_APP_CONFIG');
